import Autosuggest from 'react-autosuggest'
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormGroup } from 'reactstrap';
// import { fetchUsers } from '../../../actions/activityLogs';
import { getOrganizationUsers } from '../../../actions/addOrganization'
import '../style.css'
const UsersAuto = ({  users,  getUserActivities, dispatch,UserTextBox, setUserTextBox,organization_id }) => {
    const [dropdownOpen, setOpen] = useState(false);
    const [userSuggestions, setUserSuggestions] = useState([])
    const [suggestions, setSuggestions] = useState([])
    const onUserSuggestionsClearRequested = () => setUserSuggestions([])

    const renderSuggestion = suggestion => (
        <div className="renderedSuggestionContainer"> {suggestion.name} </div>
    )
    const getUserSuggestions = value => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0 ? [] : users.filter(user =>
            user.name.toLowerCase().slice(0, inputLength) === inputValue)
    }
    const onUserSuggestionsFetchRequested = ({ value }) => setSuggestions(getUserSuggestions(value))
  
    const getSuggestionValue = suggestion => suggestion.name
 
    const inputProps = {
        placeholder: `Search for User`,
        value: UserTextBox,
        onChange: (e, { newValue }) => {
            if(newValue==='') 
            getUserActivities('');
            setUserTextBox(newValue)}
    }
    const toggle = () => setOpen(!dropdownOpen);

    const showValue=(e,props)=>{

        const index = users.findIndex(user => user.id ===props.suggestion.id);
        getUserActivities(users[index].id)
     }
    useEffect(() => {
        // dispatch(getOrganizationUsers( null, null, organization_id, null,''));
    }, []);
    return (
        <div style={{ marginLeft: '50px' }}>
            <FormGroup>
                <Autosuggest
                    theme={{
                        input: 'adv-filter-ip-detailed-analytics-user',
                        suggestion: 'suggestion-item-detailed-analytics',
                        suggestionsContainer: 'autosuggest-suggestions-container-detailed-analytics'
                    }}
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={onUserSuggestionsFetchRequested}
                    onSuggestionsClearRequested={onUserSuggestionsClearRequested}
                    onSuggestionSelected={showValue}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                />
            </FormGroup>
        </div>
    )
}
export default connect(state => ({
    // users: state.orgUsers.users,
    // usersPending: state.orgUsers.usersPending,
    // isDataAvailable: state.orgUsers.isDataAvailable
}))(UsersAuto)